/** Minimal route transition fallback (matches prior Next `loading.tsx` intent). */
export function RouteLoading() {
  return (
    <div
      className="min-h-[100dvh] w-full bg-[#dbeafe]"
      aria-busy="true"
      aria-label="Loading"
    />
  );
}
